const favourites = {
  namespaced: true,
  state: {
    favourites: [],
  },
  getters: {
    favourites(state) {
      return state.favourites || [];
    },
    isFavouriteInList: (state) => (favourite) => {
      return state.favourites ? state.favourites.findIndex((f) => f.id == favourite.id) >= 0 : false;
    },
    favouritesCount(state) {
      return state.favourites ? state.favourites.length : 0;
    },
  },
  mutations: {
    updateFavourites(state, favourites) {
      state.favourites = favourites;
    },
  },
  actions: {
    resetFavourites({ commit }) {
      commit("updateFavourites", []);
    },
    async removeFavourite({ state, commit }, favourite) {
      try {
        const favourites = state.favourites || [];
        const idx = favourites.findIndex((f) => f.id == favourite.id);

        if (idx >= 0) {
          const newFavourites = [...favourites.slice(0, idx), ...favourites.slice(idx + 1)];
          commit("updateFavourites", newFavourites);
        }
      } catch (error) {
        console.error('Error removing favourite:', error);
      }
    },
    async addFavourite({ state, commit }, favourite) {
      try {
        let favourites = state.favourites || [];
        if (!favourites.some(f => f.id === favourite.id)) {
          favourites = [...favourites, favourite];
          commit("updateFavourites", favourites);
        }
      } catch (error) {
        console.error('Error adding favourite:', error);
      }
    },
  },
};

export default favourites;
